import { MouseEventHandler } from 'react';
import { IoChatboxOutline } from 'react-icons/io5';

import { Button, ButtonProps } from '@mantine/core';

import { CompanyProfile, Component } from 'models';

import { IntercomService } from 'services/IntercomService';

const InAppSupportBadge = ({
    label,
    component,
    company,
    isExternalLink,
    ...props
}: {
    label?: string;
    component?: Component;
    company: CompanyProfile;
    isExternalLink?: boolean;
} & ButtonProps) => {
    const onClick: MouseEventHandler = (event) => {
        event.stopPropagation();

        IntercomService.openIntercom({ companySlug: company.slug, componentId: component?.id, isExternalLink });
    };

    return (
        <Button leftSection={<IoChatboxOutline />} onClick={onClick} {...props}>
            {label || 'Send Message'}
        </Button>
    );
};

export { InAppSupportBadge };
